module.exports = __webpack_public_path__ + "static/media/springframework_image_presentation.a1b6cbc2.png";